import { render } from "./confirm-modal.vue?vue&type=template&id=5ef7ba6d&scoped=true"
import script from "./confirm-modal.vue?vue&type=script&lang=js"
export * from "./confirm-modal.vue?vue&type=script&lang=js"

import "./confirm-modal.vue?vue&type=style&index=0&id=5ef7ba6d&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ef7ba6d"]])

export default __exports__